import * as z from "zod";

export const disableContextual = {
  name: "disableContextual" as const,
  input: z.object({}),
  output: z.object({ success: z.boolean() }),
};
